import * as React from "react";
import { CarouselBlock } from "../../Pages/Ecommerce/Shared/CarouselBlock/CarouselBlock";
import { NewExhibitionCard } from "../../Partials/NewExhibitionCard/NewExhibitionCard";
import { PictureProfile } from "../../../ResizedImage/PictureProfile.csharp";
import { ExhibitionItemViewModel } from "./ExhibitionItemViewModel.csharp";
import { ExhibitionsListBlockTranslations } from "./ExhibitionsListBlockTranslations.csharp";

export interface ExhibitionsListBlockProps {
    exhibitions: ExhibitionItemViewModel[];
    title: string;
    buttonText: string;
    buttonUrl: string;
    translations: ExhibitionsListBlockTranslations;
    defaultProfile: PictureProfile;
}

export function ExhibitionsListBlock({
    exhibitions,
    title,
    buttonText,
    buttonUrl,
    translations,
    defaultProfile,
}: ExhibitionsListBlockProps) {
    if (!exhibitions || exhibitions.length === 0) {
        return null;
    }

    const displayData = exhibitions.map((ex, index) => ({
        key: `${ex.title}-${index}`,
        data: (
            <NewExhibitionCard
                title={ex.title}
                subtitle={ex.subtitle}
                image={ex.image}
                defaultProfile={defaultProfile}
                shortDescription={ex.shortDescription}
                floor={ex.floor}
                exhibitionType={ex.exhibitionType}
                isComingSoon={ex.isComingSoon}
                comingDateText={ex.isComingSoon ? `${translations.coming} ${ex.comingDateText}` : null}
                pageUrl={ex.pageUrl}
                theme={ex.theme}
                customThemeBackgroundColor={ex.customThemeBackgroundColor}
                customThemeFontColor={ex.customThemeFontColor}
                cardTranslations={ex.cardTranslations}
                isTemporary={ex.isTemporary}
                duration={ex.duration}
            />
        ),
    }));

    return (
        <div className="ExhibitionsList">
            <CarouselBlock
                title={title}
                buttonText={buttonText}
                buttonUrl={buttonUrl}
                bgColor="white"
                fullWidth
                previousSlideAriaLabel="Previous"
                nextSlideAriaLabel="Next"
                itemsPerSlideDesktop={3.5}
                itemsPerSlideMobile={1.4}
                displayData={displayData}
            />
        </div>
    );
}
